export enum EProductType {
  TREATMENT = 'treatment',
  PRODUCT = 'product'
}
